import { useWallet } from 'components/WalletContext';
import { useQuery } from 'react-query';
import { getMixpassClaimStatus } from 'utils/mixpassService';

const useMixpassWhitelistUserStatus = (whitelist: string) => {
  const { address } = useWallet();

  const {
    data: apiClaim,
    isLoading: isClaimStatusLoading,
    isError: isClaimStatusError,
  } = useQuery(
    ['mixpass-whitelist-claim-status', whitelist, address],
    async () => getMixpassClaimStatus(whitelist, address!),
    {
      enabled: Boolean(whitelist) && Boolean(address),
    }
  );

  return {
    isLoading: isClaimStatusLoading,
    isError: isClaimStatusError,
    claimStatus: apiClaim?.isClaimed,
    userClaimInfo: apiClaim?.claim,
    merkleRoot: apiClaim?.merkleRoot,
  };
};

export default useMixpassWhitelistUserStatus;
